(function initProductModal() {
  const BaseModalDialog = window.ModalDialog || window.themeCore?.ModalDialog;

  if (!BaseModalDialog) {
    window.addEventListener('theme:core-ready', initProductModal, { once: true });
    return;
  }

  if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends BaseModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        if (!openedMediaId) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${openedMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
  }
})();
